module.exports = __webpack_public_path__ + "static/img/dashuju.85c5dd90.png";